export const MAX_NUMBER_OF_TILES = 12;
export const INITIAL_ITEMS_NUMBER = 10;
